interface FacetJsonEditorFooterProps {
    isEditMode: boolean;
    onToggleMode: () => void;
    onSaveAndExecuteJson: () => void;
}

export default function FacetJsonEditorFooter({
    isEditMode,
    onToggleMode,
    onSaveAndExecuteJson,
}: FacetJsonEditorFooterProps) {
    return (
        <div className="flex items-center justify-between border-t border-[#d9dde2] bg-[#eceff2] px-4 py-2">
            <div className="flex items-center gap-2">
                <span className="text-[11px] font-medium text-[#4b5563]">View JSON</span>

                <button
                    type="button"
                    onClick={onToggleMode}
                    className={`relative h-5 w-9 rounded-full transition ${
                        isEditMode ? "bg-[#111827]" : "bg-[#9ca3af]"
                    }`}
                    aria-label="Toggle edit json mode"
                >
                    <span
                        className={`absolute top-[2px] h-4 w-4 rounded-full bg-white transition ${
                            isEditMode ? "left-[18px]" : "left-[2px]"
                        }`}
                    />
                </button>

                <span className="text-[11px] font-semibold text-[#111827]">Edit JSON</span>
            </div>

            <div className="flex items-center gap-3">
                <button
                    type="button"
                    onClick={onSaveAndExecuteJson}
                    className="rounded-md border border-[#cfd4dc] bg-[#f8fafc] px-3 py-1 text-[11px] font-semibold text-[#1f2937] hover:bg-white"
                >
                    Save &amp; Execute JSON
                </button>
            </div>
        </div>
    );
}
